import React from 'react';

import {Highlight} from './highlight';
import type {SearchHitData} from './search-hit-route';
import {cls} from '../utils';

import css from './search-hit.module.css';

type Props = {
	hit: SearchHitData;
	/**
	 * Фрагмент описания: always — всегда (страница поиска),
	 * auto — только если запрос нашёлся не в названиях (выпадающий список)
	 */
	snippet?: 'always' | 'auto';
	className?: string;
};

function mentions(text: string | undefined, words: readonly string[]): boolean {
	if (!text) return false;
	const lower = text.toLowerCase();
	return words.some((word) => lower.includes(word.toLowerCase()));
}

/** Найденная запись: название, что это, фрагмент текста с совпадением */
export const SearchHitView: React.FC<Props> = ({hit, snippet = 'always', className}) => {
	const words = hit.highlights;
	const showSnippet =
		!!hit.snippet && (snippet === 'always' || (!hit.alternativeTitle && !mentions(hit.title, words)));

	return (
		<span className={cls(css.hit, className)}>
			<span className={css.title}>
				<Highlight text={hit.title} words={words} />
			</span>
			{(hit.alternativeTitle || hit.subtitle) && (
				<span className={css.subtitle}>
					{hit.alternativeTitle && (
						<>
							Другое название: <Highlight text={hit.alternativeTitle} words={words} />
							{hit.subtitle && ' · '}
						</>
					)}
					{hit.subtitle}
				</span>
			)}
			{showSnippet && (
				<span className={css.snippet}>
					<Highlight text={hit.snippet!} words={words} />
				</span>
			)}
		</span>
	);
};
